module.exports = __webpack_public_path__ + "static/media/totle.906926c7.svg";